import { render, staticRenderFns } from "./AboutThreeColumnBlock.vue?vue&type=template&id=6a90b2e4&scoped=true&lang=pug&"
import script from "./AboutThreeColumnBlock.vue?vue&type=script&lang=js&"
export * from "./AboutThreeColumnBlock.vue?vue&type=script&lang=js&"
import style0 from "./AboutThreeColumnBlock.vue?vue&type=style&index=0&id=6a90b2e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a90b2e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a90b2e4')) {
      api.createRecord('6a90b2e4', component.options)
    } else {
      api.reload('6a90b2e4', component.options)
    }
    module.hot.accept("./AboutThreeColumnBlock.vue?vue&type=template&id=6a90b2e4&scoped=true&lang=pug&", function () {
      api.rerender('6a90b2e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/AboutThreeColumnBlock.vue"
export default component.exports